import { signal } from '@preact/signals';
import { closeChat } from '../lib/engine.js';

export type View = 'chats' | 'chat' | 'settings' | 'new-chat' | 'chat-info';

export const view = signal<View>('chats');

/** Экраны, при возврате на которые открытый чат надо закрыть. */
const ROOT_VIEWS: View[] = ['chats', 'settings', 'new-chat'];

/**
 * Переход на экран.
 *
 * replace нужен там, где возвращаться к предыдущему экрану бессмысленно.
 * Пример — создание чата: после того как чат создан, «назад» должно вести
 * к списку, а не обратно в форму создания уже созданного чата.
 */
export function go(next: View, options: { replace?: boolean } = {}): void {
  if (next === view.value && !options.replace) return;

  view.value = next;
  if (options.replace) history.replaceState({ view: next }, '');
  else history.pushState({ view: next }, '');
}

/** Возврат на шаг назад — тот же путь, что у системной кнопки «назад». */
export function back(): void {
  history.back();
}

/**
 * Связывает экраны с историей браузера.
 *
 * Без этого системный жест «назад» на Android закрывает приложение прямо из
 * чата, вместо того чтобы вернуть к списку: истории-то нет. Теперь каждый
 * переход добавляет запись, и жест ведёт себя ожидаемо. Заодно кнопка «‹»
 * в углу делает ровно то же самое, а не отдельную навигацию — иначе история
 * и состояние экранов разъезжаются.
 */
export function initHistory(): void {
  // Базовая запись: без неё первый же «назад» выбрасывает из приложения.
  history.replaceState({ view: 'chats' }, '');

  addEventListener('popstate', (event: PopStateEvent) => {
    const next = (event.state as { view?: View } | null)?.view ?? 'chats';
    if (ROOT_VIEWS.includes(next)) closeChat();
    view.value = next;
  });
}
